<template>
    <div>
        <table class="qra-table-wrapper">
            <tr>
                <th class="header" colspan="4">{{ $t('Name') }}</th>
                <th class="header" colspan="2">{{ $t('At Survey') }}</th>
                <th class="header" colspan="2">{{ $t('Mitigated') }}</th>
                <th class="header" colspan="2">{{ $t('#RIs') }}</th>
                <th class="header" colspan="2"></th>
            </tr>

            <tr>
                <td class="col1" colspan="4">
                    <i
                        class="el-icon el-icon-arrow-right"
                        :class="expandedMenu ? 'expanded' : ''"
                        @click="expandedMenu = !expandedMenu"
                    ></i>
                    {{ question.caption }}
                </td>
                <td class="col2" colspan="2">
                    <el-select
                        :disabled="!editable"
                        v-model="data.at_survey"
                        filterable
                        :placeholder="$t('Select')"
                        class="w-100"
                        size="small"
                    >
                        <el-option
                            v-for="item in atSurveyList"
                            :key="item.cd_value"
                            :label="item.cd_value"
                            :value="item.cd_value"
                        >
                        </el-option>
                    </el-select>
                </td>
                <td class="col3" colspan="2">
                    <el-select
                        :disabled="!editable"
                        v-model="data.mitigated"
                        filterable
                        :placeholder="$t('Select')"
                        class="w-100"
                        size="small"
                    >
                        <el-option
                            v-for="item in filteredMitigatedList"
                            :key="item.cd_value"
                            :label="item.cd_value"
                            :value="item.cd_value"
                        >
                        </el-option>
                    </el-select>
                </td>
                <td class="col4 center" colspan="2">
                    {{ question.data.risk_improvements && question.data.risk_improvements.length }}
                </td>
                <td class="col5 center" colspan="2">
                    <el-button
                        :disabled="!editable"
                        size="small"
                        type="primary"
                        class="mr-10px"
                        @click="onAddRI"
                    >
                        <i class="fa fa-plus"></i>
                        <template> {{ $t('ADD RI') }} </template>
                    </el-button>
                </td>
            </tr>
        </table>
        <div v-if="expandedMenu">
            <div>
                <htmleditor :editable="editable" v-model="data.comments" class="w-100"></htmleditor>
            </div>
            <div>
                <htmleditor
                    v-model="question.help_text"
                    :editable="false"
                    class="w-100"
                ></htmleditor>
            </div>
        </div>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import Visit from '@/data/Visit';
import Htmleditor from '../htmleditor/htmleditor.vue';

export default {
    name: 'qra',
    components: { Htmleditor },
    props: {
        question: { type: FormQuestion, required: true },
        editable: {
            type: Boolean,
            default: true,
        },
        visit: {
            type: Visit,
            required: true,
        },
    },
    data() {
        return {
            expandedMenu: false,
            data: {},
        };
    },
    created() {
        // todo musa get data from visit
        if (!this.question.data.return_value) {
            // on first load fill default values
            // set default values
            this.data = { ...this.data, comments: this.question.ques_comment };
        } else {
            this.data = JSON.parse(this.question.data.return_value || '{}');
        }
    },
    mounted() {},
    watch: {
        data: {
            // This will let Vue know to look inside the array
            deep: true,
            handler(newVal) {
                this.question.data.return_value = JSON.stringify(newVal);
            },
        },
        'data.at_survey': function (v) {
            if (this.isQRAIH && parseInt(v, 10) < parseInt(this.data.mitigated, 10)) {
                this.data.mitigated = null;
            }
            if (this.isQRARI && parseInt(v, 10) > parseInt(this.data.mitigated, 10)) {
                this.data.mitigated = null;
            }
        },
    },
    computed: {
        isQRARI() {
            return this.question.isQRARI;
        },
        isQRAIH() {
            return this.question.isQRAIH;
        },
        atSurveyList() {
            return this.question.control_data.map((x) => ({
                cd_value: x.cd_value,
            }));
        },
        mitigatedList() {
            return this.question.control_data.map((x) => ({
                cd_value: x.cd_value,
            }));
        },
        filteredMitigatedList() {
            if (this.isQRAIH) {
                return this.mitigatedList.filter(
                    (item) => parseInt(item.cd_value, 10) <= parseInt(this.data.at_survey, 10)
                );
            }
            if (this.isQRARI) {
                return this.mitigatedList.filter(
                    (item) => parseInt(item.cd_value, 10) >= parseInt(this.data.at_survey, 10)
                );
            }
            return null;
        },
    },
    methods: {
        onAddRI() {
            this.$emit('onAddRI');
        },
    },
};
</script>

<style lang="scss">
.qra-table-wrapper {
    width: 100%;
    table-layout: fixed;
    border: 1px solid #ebeef5;
    line-height: 20px !important;
    overflow: auto;
    word-break: break-word;

    .expanded {
        transform: rotate(90deg);
    }

    td {
        border-right: 1px solid #ebeef5;
        padding: 10px;
    }

    .input {
        padding: 0px;

        .el-input__inner {
            padding: 0px 0px 0px 15px;
        }
    }

    .right {
        text-align: right;
    }

    .center {
        text-align: center;
    }

    .col1 {
        background: #f6f6f8;
    }

    .col2 {
        background: #f6f6f8;
    }

    .col3 {
        background: #f6f6f8;
    }

    .col4 {
        background: #f6f6f8;
    }

    .col5 {
        background: #f6f6f8;
    }

    th {
    }

    tr {
        border-bottom: 1px solid #ebeef5;
        height: 32px;
    }

    .header {
        background: #d3dce6;
        text-align: center;
        border-right: 1px solid #ebeef5;
    }

    .el-col {
        border-radius: 4px;
        border-bottom: 1px solid #ebeef5;
    }
}

.el-row {
    // margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}

.add-ri-button {
    opacity: 0.7;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.68;
    letter-spacing: normal;
    text-align: right;
    color: #ffffff;

    &:hover {
        opacity: 1;
    }
}
</style>
